import { Column, Scrolling } from 'devextreme-react/data-grid';
import React from 'react';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import useFormatMessage from '../../../utils/useFormatMessage';

const AracHareketleri = ({ data }) => {
    const { t } = useFormatMessage();



    const formatData = (rawData) => {
        // Sort data by process_date to ensure chronological order
        const sortedData = [...rawData].sort((a, b) =>
            new Date(a.process_date) - new Date(b.process_date)
        );

        return sortedData.map((item, index) => ({
            ...item,
            current_location: index > 0 ? sortedData[index - 1].data : null,
            target_location: item.data
        }));
    };

    return (
        <DatagridCustom
            dataSource={data ? formatData(data) : []}
            height={400}
        >
            <Scrolling mode="infinite" showScrollbar="always" />
            <Column
                caption={t("Tarih")}
                dataField="process_date"
                alignment='center'
                dataType="date"
                format="dd/MM/yyyy HH:mm"
                sortOrder='asc'
            />
            <Column
                caption={t("İşlem")}
                dataField="operation"
                alignment='center'
            />
            <Column
                caption={t("Bulunduğu Adres")}
                dataField="current_location"
                alignment='center'
            />
            <Column
                caption={t("Gittiği Adres")}
                dataField="target_location"
                alignment='center'
            />
            <Column
                caption={t("Park Şoförü")}
                dataField=""
                alignment='center'
            />
            <Column
                caption={t("İşlem Yapan Kullanıcı")}
                dataField="username"
                alignment='center'
            />
        </DatagridCustom>
    );
};

export default AracHareketleri;